import React, { FC } from 'react';
import { callOrUse } from '../../../utils/callOrUse';
import styles from './Lasso.scss';
import { IInner, IOuter } from './Lasso.types';

export const LassoComponent: FC<IOuter & IInner> = ({
  selectedAreaStyle,
  children,
  handleLassoStart,
  saveScrollingComponentWrapperRef,
  saveRef,
}) => {
  return (
    <div className={styles.lassoWrapper} ref={saveRef} onMouseDown={handleLassoStart}>
      {callOrUse(children, { saveScrollingComponentWrapperRef, selectedAreaStyle })}
    </div>
  );
};
